import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledDashboardFiltersContainer = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        padding: ${spacing * 4}px ${spacing * 6}px;
        border-bottom: 1px solid ${palette.neutral[200]};
    `
)
